<div class="tableHeader">
  @if (notice()) {
    <h4 class="informationalNotice">{{ notice() }}</h4>
  }
  <span class="spacer"></span>
  <mat-paginator [pageSizeOptions]="[10, 20, 40]" [pageSize]="10" [showFirstLastButtons]="true"></mat-paginator>
</div>
<div class="tableWrapper">
  <table mat-table [dataSource]="datasource" matSort class="paginatedTable bordered-table" [multiTemplateDataRows]="true">
    <ng-container matColumnDef="details">
      <th class="buttonHeader" mat-header-cell *matHeaderCellDef>Details</th>
      <td class="centered-cell" mat-cell *matCellDef="let candidate">
        <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === candidate ? null : candidate); $event.stopPropagation()">
          @if (expandedElement !== candidate) {
            <mat-icon>keyboard_arrow_down</mat-icon>
          }
          @if (expandedElement === candidate) {
            <mat-icon>keyboard_arrow_up</mat-icon>
          }
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="add">
      <th class="buttonHeader" mat-header-cell *matHeaderCellDef>Add</th>
      <td class="centered-cell" mat-cell *matCellDef="let candidate">
        <button mat-icon-button (click)="addToSchedule(candidate)">
          <mat-icon>add</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="model">
      <th class="modelColumn" mat-header-cell *matHeaderCellDef mat-sort-header="model">IEC Model</th>
      <td mat-cell *matCellDef="let candidate" class="modelColumn">
        <span>
          <div class="imageWrapper"><img [src]="getImageFileName(candidate)" class="modelImage" alt="Model Image"/></div>
          <label class="modelDescriptionLabel">{{ candidate.modelSizeCharacteristic?.ratingsModel?.description || '' }}</label>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="size">Size</th>
      <td mat-cell *matCellDef="let candidate">{{ candidate.modelSizeCharacteristic.sizeCode }}</td>
    </ng-container>
    <ng-container matColumnDef="width">
      <th class="commentsCell" mat-header-cell *matHeaderCellDef mat-sort-header="width">Width</th>
      <td mat-cell *matCellDef="let candidate">{{ candidate.modelSizeCharacteristic.width }}</td>
    </ng-container>
    <ng-container matColumnDef="depth">
      <th class="commentsCell" mat-header-cell *matHeaderCellDef mat-sort-header="depth">Depth</th>
      <td mat-cell *matCellDef="let candidate">{{ candidate.modelSizeCharacteristic.depth }}</td>
    </ng-container>
    <ng-container matColumnDef="height">
      <th class="commentsCell" mat-header-cell *matHeaderCellDef mat-sort-header="height">Height</th>
      <td mat-cell *matCellDef="let candidate">{{ candidate.modelSizeCharacteristic.height }}</td>
    </ng-container>
    <ng-container matColumnDef="dryWeight">
      <th class="commentsCell" mat-header-cell *matHeaderCellDef mat-sort-header="dryWeight">Dry Weight</th>
      <td mat-cell *matCellDef="let candidate">{{ candidate.modelSizeCharacteristic.dryWeight }}</td>
    </ng-container>
    <ng-container matColumnDef="targetDeviation">
      <th class="commentsCell" mat-header-cell *matHeaderCellDef mat-sort-header="targetDeviation">Target Deviation</th>
      <td mat-cell *matCellDef="let candidate">{{ candidate.targetDeviation | percent: '1.1-3' }}</td>
    </ng-container>
    <ng-container matColumnDef="costFactor">
      <th matTooltipClass="costFactorInfo" matTooltip="Based on your product output results, the least expensive option will show a Cost Factor 1. All other product outputs will generate a cost factor in relation." class="commentsCell"
        mat-header-cell *matHeaderCellDef mat-sort-header="costFactor">Cost Factor
      </th>
      <td mat-cell *matCellDef="let candidate" matTooltipClass="costFactorInfo"
        matTooltip="Based on your product output results, the least expensive option will show a Cost Factor 1. All other product outputs will generate a cost factor in relation.">{{ candidate.costFactor }}
      </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let candidate" [attr.colspan]="displayColumns.length">
        <div class="candidateDetailContainer" [class.expandedContent]="candidate == expandedElement">
          <app-selection-candidate-detail [candidate]="candidate" [metricInput]="metricInput()" [isSureflow]="isSureflow(candidate)">
          </app-selection-candidate-detail>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let candidate; columns: displayColumns;" [class.expandedRow]="candidate == expandedElement"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="candidate-detail-row"></tr>
  </table>
</div>
